import { render, staticRenderFns } from "./RateGroupsList.vue?vue&type=template&id=4ce1f9bc&scoped=true&"
import script from "./RateGroupsList.vue?vue&type=script&lang=js&"
export * from "./RateGroupsList.vue?vue&type=script&lang=js&"
import style0 from "./RateGroupsList.vue?vue&type=style&index=0&id=4ce1f9bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce1f9bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ce1f9bc')) {
      api.createRecord('4ce1f9bc', component.options)
    } else {
      api.reload('4ce1f9bc', component.options)
    }
    module.hot.accept("./RateGroupsList.vue?vue&type=template&id=4ce1f9bc&scoped=true&", function () {
      api.rerender('4ce1f9bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/RateGroups/RateGroupsList.vue"
export default component.exports